<template>
  <v-container fluid>
    <!--<google-sign-in/>-->

    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-card class="pa-4 ma-4" elevation="2">
      <v-form @submit.prevent="insertUserFeedback">
        <v-select
          v-model="userCommentType"
          :items="userCommentTypeSelectOptions"
          item-text="title"
          item-value="value"
          label="Select feedback type"
          outlined
          required
        />

        <v-textarea
          v-model="userComment"
          label="Your feedback"
          rows="4"
          outlined
          required
        />

        <v-btn type="submit" color="primary" class="mt-3" :disabled="!userComment">
          Submit
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { INSERT_USER_FEEDBACK } from "../lib/helper/queries";

export default {
  computed: {
    ...mapState(["loggedInGoogle", "userGoogle"]),
  },
  data() {
    return {
      snackbar: {
        show: false,
        message: "",
        color: "info",
        timeout: 3000,
      },
      userComment: "",
      userCommentType: 0,
      userCommentTypeSelectOptions: [
        { title: "Feedback", value: 0 },
        { title: "Enhancement", value: 1 },
        { title: "Bug", value: 2 },
      ],
    };
  },
  methods: {
    async insertUserFeedback() {
        console.log(this.userGoogle)
      try {
        const resp = await this.$apollo.query({
          query: INSERT_USER_FEEDBACK,
          variables: {
            object: {
              type: 0,
              comment: this.userComment,
              type: this.userCommentType,
              user: {
                data: {
                  email: this.userGoogle.email,
                  google_id: this.userGoogle.uid,
                },
                on_conflict: {
                  update_columns: ["updated_at"],
                  constraint: "users_email_key",
                },
              },
            },
          },
          fetchPolicy: "no-cache"
        });

        if (resp?.data) {
          this.snackbar.message = "Thank you for your feedback";
          this.snackbar.color = "success";
          this.snackbar.show = true;
          this.userComment = ""; // clear after submission
          this.userCommentType = 0;
        }
      } catch (e) {
        console.error(e);
        this.snackbar.message = "Sorry, there was an error submitting";
        this.snackbar.color = "error";
        this.snackbar.show = true;
      }
    },
  },
};
</script>
